<template>
  <b-modal
    id="delete-baseline-modal"
    ref="deletebaselinemodal"
    title="Are you sure you want to delete this baseline?"
    name="delete-baseline-modal"
    size="lg"
    :busy="loading"
    ok-title="Delete"
    close-title="Cancel"
    hide-header-close
    @ok="handleOk">
    This action can not be undone
    <div slot="modal-ok" v-if="loading">
      <icon name="spinner" pulse></icon> Deleting
    </div>
  </b-modal>
</template>

<script>
  import utilsMixin from '@/mixins/utils'
  export default {
    data () {
      return {
        loading: false
      }
    },
    props: {
      baseline: Object
    },
    mixins: [utilsMixin],
    methods: {
      handleOk (e) {
        e.preventDefault()
        this.loading = true
        this.submitData()
      },
      submitData () {
        this.$ga.event('baseline', 'delete', this.baseline.baseline_id, 1)
        this.$http.delete(
          `/api/baseline/${this.baseline.baseline_id}`
        ).then(response => {
          window.AP.flag.create({
            title: 'Success!',
            body: 'Baseline deleted successfully',
            type: 'success',
            close: 'auto'
          })
          this.loading = false
          this.setTheState()
          this.$refs.deletebaselinemodal.hide()
        }, error => {
          let errorString = this.createErrorStringFromResponse(error.response.data)
          window.AP.flag.create({
            title: 'Error',
            body: `There was a problem deleting your baseline: ${errorString}`,
            type: 'error'
          })
          this.loading = false
        })
      },
      setTheState () {
        this.$store.commit('setNeedToRefreshBaselineList', true)
        this.$store.commit('setCurrentBaseline', null)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DeleteBaselineModal.vue?833ddf64